import axios, { CancelTokenSource } from 'axios';
import { v4 as uuidv4 } from 'uuid';

export function generateBoundaryVal() {
  return uuidv4();
}

export function getFooter(boundaryVal: string) {
  return `\r\n--${boundaryVal}--\r\n`;
}

export function createCancelToken(): CancelTokenSource {
  const CancelToken = axios.CancelToken;
  return CancelToken.source();
}

export function getContentHeader(contentDispositionName: string, fileName: string, fileSize: number) {
  let contents = `Content-Disposition: name="${contentDispositionName}"; filename="${fileName}"\r\n`;
  contents += 'Content-Type: application/octet-stream\r\n';
  contents += `Content-Length: ${fileSize}\r\n\r\n`;
  return contents;
}

// `file` may be any Blob (e.g. one chunk of a File); pass `fileName` when it has no name of its own.
export function createRequestBodyBlob(
  contentDispositionName: string,
  boundaryVal: string,
  file: Blob,
  requestHeader: string,
  fileName: string = (file as File).name
) {
  const boundaryStr = `--${boundaryVal}\r\n`;
  const contentHeader = getContentHeader(contentDispositionName, fileName, file.size);
  const contentFooter = getFooter(boundaryVal);
  const contents = boundaryStr + requestHeader + boundaryStr + contentHeader;
  return new Blob([contents, file, contentFooter]);
}
